/** @module csi/SiteAdmin/ImageWhereUsedTable */
define([
	"dojo/_base/declare",
	"csi/table/Widget"
], function(declare, Table) {

	return declare(Table, {
		bForceBrowse: true,
		disableCustomViewToolbar: true,
		disableTabMatching: true,

		startup: function() {
			var fd = this.defView.m_formData;
			fd.m_bAllowSelections = false;
			fd.m_bAllowSelectionActions = false;
			fd.linkTarget = "_blank";

			return this.inherited(arguments);
		}
	});
});
